export enum SettingValueType {
  ATTACHMENT = 'ATTACHMENT',
  BOOLEAN = 'BOOLEAN',
  DATE = 'DATE',
  JSON = 'JSON',
  HTML = 'HTML',
  NUMBER = 'NUMBER',
  TEXT = 'TEXT',
  STRUCTURE_NODE_MAPPING = 'STRUCTURE_NODE_MAPPING',
  FILE = 'FILE'
}
